/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navtitles_Faq1Inputs */

const en_navtitles_faq1 = /** @type {(inputs: Navtitles_Faq1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQs`)
};

/**
* | output |
* | --- |
* | "FAQs" |
*
* @param {Navtitles_Faq1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const navtitles_faq1 = /** @type {((inputs?: Navtitles_Faq1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navtitles_Faq1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_navtitles_faq1(inputs)
});
export { navtitles_faq1 as "navTitles_faq" }